var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.55556 0C3.06489 0 2.66667 0.3584 2.66667 0.8V1.6H1.77778C0.8 1.6 0 2.32 0 3.2V14.4C0 15.28 0.8 16 1.77778 16H14.2222C15.2 16 16 15.28 16 14.4V3.2C16 2.32 15.2 1.6 14.2222 1.6H13.3333V0.8C13.3333 0.3584 12.9351 0 12.4444 0C11.9538 0 11.5556 0.3584 11.5556 0.8V1.6H4.44444V0.8C4.44444 0.3584 4.04622 0 3.55556 0ZM1.77778 5.6H14.2222V13.6C14.2222 14.0416 13.824 14.4 13.3333 14.4H2.66667C2.176 14.4 1.77778 14.0416 1.77778 13.6V5.6Z",
    fill: "#A4A4FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.60a445f824a7abf705118c7383e81645.svg";
export { ForwardRef as ReactComponent };